/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const $path = location.pathname;
	const pink = '#dc7864';
	const blue = '#95b0e7';
	const green = '#9dbe5a';
	const orange = '#e8a73b';
	const mainColor1 = '#f37868'; // サーモンピンク（「VIマニュアル」のキーヴィジュアルの色）
	const mainColor2 = '#5588c6'; // 濃い水色（「VIマニュアル」のキーヴィジュアルの色）
	const mainColor3 = '#6cafe0'; // 明るい水色（「VIマニュアル」のキーヴィジュアルの色）
	const mainColor4 = '#72b4b1'; // 明るい薄緑（「VIマニュアル」のキーヴィジュアルの色）

	// 最小値と最大値を揃える（y軸の目盛りが１つの場合）
	const updateScale = (_chart) => {
		const chartData = _chart.controller.boxes;
		let yAxesArr = _chart.options.scales.yAxes;
		let minArr = [];
		let maxArr = [];
		// それぞれの最小値と最大値を取得
		for(let i=0; i<chartData.length; i++) {
			if(chartData[i].type === 'linear') {
				minArr.push(chartData[i].start);
				maxArr.push(chartData[i].end);
			}
		}
		// 最小値と最大値を再設定
		for(let i=0; i<yAxesArr.length; i++) {
			yAxesArr[i].ticks.min = Math.min(...minArr);
			yAxesArr[i].ticks.max = Math.max(...maxArr);
		}
		_chart.update();
	};

	// <財務ハイライト>
	const performanceDataCharts = () => {
		// グラフ（売上高／営業利益／親会社株主に帰属する当期純利益／1株当たり当期純利益）
		let csvFilePath = '/ir/highlight/performance_data/highlight.csv';
		const chartCanvas = document.querySelectorAll('.js-chart');
		if(chartCanvas.length) {
			let labelsIdx;
			let labelsArr = [];
			let chart1Idx;
			let chart1data1; // 「売上高」第1四半期(累計期間)
			let chart1data2; // 「売上高」第2四半期（中間期）(累計期間)
			let chart1data3; // 「売上高」第3四半期(累計期間)
			let chart1data4; // 「売上高」通期
			let chart2Idx;
			let chart2data1; // 「営業利益」第1四半期(累計期間)
			let chart2data2; // 「営業利益」第2四半期（中間期）(累計期間)
			let chart2data3; // 「営業利益」第3四半期(累計期間)
			let chart2data4; // 「営業利益」通期
			let chart3Idx;
			let chart3data1; // 「親会社株主に帰属する当期純利益」第1四半期(累計期間)
			let chart3data2; // 「親会社株主に帰属する当期純利益」第2四半期（中間期）(累計期間)
			let chart3data3; // 「親会社株主に帰属する当期純利益」第3四半期(累計期間)
			let chart3data4; // 「親会社株主に帰属する当期純利益」通期
			let chart4Idx;
			let chart4data1; // 「一株当たり当期純利益」第1四半期(累計期間)
			let chart4data2; // 「一株当たり当期純利益」第2四半期（中間期）(累計期間)
			let chart4data3; // 「一株当たり当期純利益」第3四半期(累計期間)
			let chart4data4; // 「一株当たり当期純利益」通期
			let tableHtml = '';


			const req = new XMLHttpRequest();
			req.open('get', csvFilePath, true);
			req.send(null);
			req.onload = function(){
				let tmp = req.responseText.split('\n');

				// tmp.shift(); // 見出し行削除
				tmp.forEach((val, idx) => {
					const data = val.split(',').filter(Boolean);
					if(data.indexOf('業績推移') !== -1) {
						labelsIdx = idx;
					}
					if(idx === labelsIdx+1 && data.indexOf('会計年度') !== -1) {
						labelsArr = data;
						labelsArr.shift();
						// 表
						tableHtml += '<tr><th></th><th>'+ labelsArr.join('</th><th>') +'</th></tr>';
					}

					// 売上高
					if(String(data[0]).indexOf('売上高') !== -1) {
						chart1Idx = idx;
						chart1data4 = data;
						chart1data4.splice(0,2);
						// 表
						tableHtml += '<tr><th>売上高（百万円）</th>';
						for(let i=0; i<chart1data4.length; i++) {
							if(chart1data4[i].replace(/\r/g, '') === '-') {
								tableHtml += '<td>'+ chart1data4[i].toLocaleString() +'</td>';
							} else {
								tableHtml += '<td>'+ Number(chart1data4[i]).toLocaleString() +'</td>';
							}
						}
						tableHtml += '</tr>';
					}
					if(idx === chart1Idx+3 && data.indexOf('第1四半期(累計期間)') !== -1) {
						chart1data1 = data;
						chart1data1.shift();
					}
					if(idx === chart1Idx+2 && data.indexOf('第2四半期（中間期）(累計期間)') !== -1) {
						chart1data2 = data;
						chart1data2.shift();
					}
					if(idx === chart1Idx+1 && data.indexOf('第3四半期(累計期間)') !== -1) {
						chart1data3 = data;
						chart1data3.shift();
					}

					// 営業利益
					if(String(data[0]).indexOf('営業利益') !== -1) {
						chart2Idx = idx;
						chart2data4 = data;
						chart2data4.splice(0,2);
						// 表
						tableHtml += '<tr><th>営業利益（百万円）</th>';
						for(let i=0; i<chart2data4.length; i++) {
							if(chart2data4[i].replace(/\r/g, '') === '-') {
								tableHtml += '<td>'+  chart2data4[i].toLocaleString() +'</td>';
							} else {
								tableHtml += '<td>'+ Number(chart2data4[i]).toLocaleString() +'</td>';
							}
						}
						tableHtml += '</tr>';
					}
					if(idx === chart2Idx+3 && data.indexOf('第1四半期(累計期間)') !== -1) {
						chart2data1 = data;
						chart2data1.shift();
					}
					if(idx === chart2Idx+2 && data.indexOf('第2四半期（中間期）(累計期間)') !== -1) {
						chart2data2 = data;
						chart2data2.shift();
					}
					if(idx === chart2Idx+1 && data.indexOf('第3四半期(累計期間)') !== -1) {
						chart2data3 = data;
						chart2data3.shift();
					}

					// 親会社株主に帰属する当期純利益（百万円）
					if(String(data[0]).indexOf('親会社株主に帰属する当期純利益') !== -1) {
						chart3Idx = idx;
						chart3data4 = data;
						chart3data4.splice(0,2);
						// 表
						tableHtml += '<tr><th>親会社株主に帰属する<br>当期純利益（百万円）</th>';
						for(let i=0; i<chart3data4.length; i++) {
							if(chart3data4[i].replace(/\r/g, '') === '-') {
								tableHtml += '<td>'+ chart3data4[i].toLocaleString() +'</td>';
							} else {
								tableHtml += '<td>'+ Number(chart3data4[i]).toLocaleString() +'</td>';
							}
						}
						tableHtml += '</tr>';
					}
					if(idx === chart3Idx+3 && data.indexOf('第1四半期(累計期間)') !== -1) {
						chart3data1 = data;
						chart3data1.shift();
					}
					if(idx === chart3Idx+2 && data.indexOf('第2四半期（中間期）(累計期間)') !== -1) {
						chart3data2 = data;
						chart3data2.shift();
					}
					if(idx === chart3Idx+1 && data.indexOf('第3四半期(累計期間)') !== -1) {
						chart3data3 = data;
						chart3data3.shift();
					}

					// 一株当たり当期純利益（百万円）
					if(String(data[0]).indexOf('一株当たり当期純利益') !== -1) {
						chart4Idx = idx;
						chart4data4 = data;
						chart4data4.splice(0,2);
						// 表
						tableHtml += '<tr><th>一株当たり当期純利益（円）</th>';
						for(let i=0; i<chart4data4.length; i++) {
							console.log('chart4data4[i]',chart4data4[i])
							let thisNum;
							if(chart3data4[i].replace(/\r/g, '') === '-') {
								thisNum = chart3data4[i].replace(/\r/g, '');
							} else {
								thisNum = Number(chart4data4[i]).toLocaleString(undefined, {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2
								});
							}
							console.log('thisNum',thisNum)
							tableHtml += '<td>'+ thisNum +'</td>';
						}
						tableHtml += '</tr>';
					}
					if(idx === chart4Idx+3 && data.indexOf('第1四半期(累計期間)') !== -1) {
						chart4data1 = data;
						chart4data1.shift();
					}
					if(idx === chart4Idx+2 && data.indexOf('第2四半期（中間期）(累計期間)') !== -1) {
						chart4data2 = data;
						chart4data2.shift();
					}
					if(idx === chart4Idx+1 && data.indexOf('第3四半期(累計期間)') !== -1) {
						chart4data3 = data;
						chart4data3.shift();
					}
				});

				// グラフ
				chartCanvas.forEach((ele, idx) => {
					let thisId = ele.getAttribute('id');
					let ctx01 = document.querySelector('#'+ thisId);

					if(thisId === 'chart01') { // 売上高（百万円）
						let myBarChart = new Chart(ctx01, {
							type: 'bar',
							data: {
								labels: labelsArr,
								datasets: [{
									label: '第1四半期',
									data: chart1data1,
									backgroundColor: mainColor4,
								},{
									label: '第2四半期（中間期）',
									data: chart1data2,
									backgroundColor: mainColor3,
								},{
									label: '第3四半期',
									data: chart1data3,
									backgroundColor: mainColor2,
								},{
									label: '通期',
									data: chart1data4,
									backgroundColor: mainColor1,
								}],
							},
							options: {
								FilterLegend: true,
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										ticks: {
											// suggestedMax: 100000,
											suggestedMin: 0,
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											color: '#e3e3e3',
											zeroLineColor: "#000"
										}
									}],
									xAxes: [{
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										// categoryPercentage: 0.4,
										ticks: {
											maxRotation: 0,
											minRotation: 0,
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												}else{
													return val;
												}
											}
										}
									}]
								},
								
								tooltips: {
									callbacks: {
										label: function(tooltipItems, data){
											return data.datasets[tooltipItems.datasetIndex].label + '：' + tooltipItems.yLabel.toLocaleString();
										}
									}
								}
							}
						});
						// updateScale(myBarChart);
					} else if(thisId === 'chart02') { // 営業利益（百万円）
						let myBarChart = new Chart(ctx01, {
							type: 'bar',
							data: {
								labels: labelsArr,
								datasets: [{
									label: '第1四半期',
									data: chart2data1,
									backgroundColor: mainColor4,
								},{
									label: '第2四半期（中間期）',
									data: chart2data2,
									backgroundColor: mainColor3,
								},{
									label: '第3四半期',
									data: chart2data3,
									backgroundColor: mainColor2,
								},{
									label: '通期',
									data: chart2data4,
									backgroundColor: mainColor1,
								}],
							},
							options: {
								FilterLegend: true,
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer'
									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default'
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										ticks: {
											// suggestedMax: 100000,
											suggestedMin: 0,
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											color: '#e3e3e3',
											zeroLineColor: "#000"
										}
									}],
									xAxes: [{
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										// categoryPercentage: 0.4,
										ticks: {
											maxRotation: 0,
											minRotation: 0,
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												}else{
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItems, data){
											return data.datasets[tooltipItems.datasetIndex].label + '：' + tooltipItems.yLabel.toLocaleString();
										}
									}
								}
							}
						});
						// updateScale(myBarChart);
					} else if(thisId === 'chart03') { // 親会社株主に帰属する当期純利益（百万円）
						let myBarChart = new Chart(ctx01, {
							type: 'bar',
							data: {
								labels: labelsArr,
								datasets: [{
									label: '第1四半期',
									data: chart3data1,
									backgroundColor: mainColor4,
								},{
									label: '第2四半期（中間期）',
									data: chart3data2,
									backgroundColor: mainColor3,
								},{
									label: '第3四半期',
									data: chart3data3,
									backgroundColor: mainColor2,
								},{
									label: '通期',
									data: chart3data4,
									backgroundColor: mainColor1,
								}],
							},
							options: {
								FilterLegend: true,
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer'
									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default'
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										ticks: {
											// suggestedMax: 100000,
											suggestedMin: 0,
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											color: '#e3e3e3',
											zeroLineColor: "#000"
										}
									}],
									xAxes: [{
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										// categoryPercentage: 0.4,
										ticks: {
											maxRotation: 0,
											minRotation: 0,
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												}else{
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItems, data){
											return data.datasets[tooltipItems.datasetIndex].label + '：' + tooltipItems.yLabel.toLocaleString();
										}
									}
								}
							}
						});
						// updateScale(myBarChart);
					} else if(thisId === 'chart04') { // 一株当たり当期純利益（百万円）
						let myBarChart = new Chart(ctx01, {
							type: 'bar',
							data: {
								labels: labelsArr,
								datasets: [{
									label: '第1四半期',
									data: chart4data1,
									backgroundColor: mainColor4,
								},{
									label: '第2四半期（中間期）',
									data: chart4data2,
									backgroundColor: mainColor3,
								},{
									label: '第3四半期',
									data: chart4data3,
									backgroundColor: mainColor2,
								},{
									label: '通期',
									data: chart4data4,
									backgroundColor: mainColor1,
								}],
							},
							options: {
								FilterLegend: true,
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer'
									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default'
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										ticks: {
											// suggestedMax: 100000,
											suggestedMin: 0,
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											color: '#e3e3e3',
											zeroLineColor: "#000"
										}
									}],
									xAxes: [{
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										// categoryPercentage: 0.4,
										ticks: {
											maxRotation: 0,
											minRotation: 0,
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												}else{
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItems, data){
											return data.datasets[tooltipItems.datasetIndex].label + '：' + tooltipItems.yLabel.toLocaleString(undefined, {
												minimumFractionDigits: 2,
												maximumFractionDigits: 2
											});
										}
									}
								}
							}
						});
						// updateScale(myBarChart);
					}
				});

				// 表
				if(document.querySelectorAll('.js-csvTbl-body').length) {
					document.querySelector('.js-csvTbl-body').insertAdjacentHTML('beforeend', tableHtml);
				}
			}
		}
	};

	// <財務データ>
	const financeDataCharts = () => {
		let csvFilePath = '/ir/highlight/performance_data/';
		const chartCanvas = document.querySelectorAll('.js-chart');
		if(chartCanvas.length) {	
			let thisName = '';
			let graphName = '';
			thisName = 'highlight';

			const req = new XMLHttpRequest();
			req.open('get', csvFilePath + thisName +'.csv', true);
			req.send(null);
			req.onload = function(){
				let tmp = req.responseText.split('\n');
				let balanceSheetFlgIdx;
				let highlightFlgIdx;
				let cfFlgIdx;
				let chart1Labels;
				let chart2Labels;
				let chart5Labels;
				let chart1Data1; // 総資産（百万円）
				let chart1Data2; // 純資産（百万円）
				let chart1Data3; // 自己資本比率（％）
				let chart2Data; // ROS（％）
				let chart3Data; // ROE（％）
				let chart4Data1; // Net有利子負債
				let chart4Data2; // NetD/Eレシオ
				let chart5Data1; // 営業活動によるキャッシュ・フロー（百万円）
				let chart5Data2; // 投資活動によるキャッシュ・フロー（百万円）
				let chart5Data3; // 財務活動によるキャッシュ・フロー（百万円）
				let chart5Data4; // フリー・キャッシュ・フロー（百万円）
				let tableHtml = '';
				let rosHtml = '';
				let roeHtml = '';
				let netHtml = '';
				let netDEHtml = '';
				let cf1Html = '';
				let cf2Html = '';
				let cf3Html = '';
				let cf4Html = '';

				tmp.forEach((val2, idx2) => {
					const data = val2.split(',').filter(Boolean);

					// 総資産・純資産・自己資本比率
					if(data.indexOf('バランスシートの状況') !== -1) {
						balanceSheetFlgIdx = idx2;
					}
					if(idx2 == Number(balanceSheetFlgIdx + 1)) {
						chart1Labels = data;
						chart1Labels = chart1Labels.filter(item => item !== '\r');
						chart1Labels.shift();

						// 表
						tableHtml += '<tr><th></th><th>'+ chart1Labels.join('</th><th>') +'</th></tr>';
					}
					if(data.indexOf('総資産（百万円）') !== -1) {
						chart1Data1 = data;
						chart1Data1.shift();

						// 表
						tableHtml += '<tr><th>総資産（百万円）</th>';
						for(let i=0; i<data.length; i++) {
							tableHtml += '<td>'+ Number(data[i]).toLocaleString() +'</td>';
						}
						tableHtml += '</tr>';
					}
					if(data.indexOf('純資産（百万円）') !== -1) {
						chart1Data2 = data;
						chart1Data2.shift();
						
						// 表
						tableHtml += '<tr><th>純資産（百万円）</th>';
						for(let i=0; i<data.length; i++) {
							tableHtml += '<td>'+ Number(data[i]).toLocaleString() +'</td>';
						}
						tableHtml += '</tr>';
					}
					if(data.indexOf('自己資本比率（％）') !== -1) {
						chart1Data3 = data;
						chart1Data3.shift();
						chart1Data3 = chart1Data3.filter(item => item !== '\r');

						// 表
						tableHtml += '<tr><th>自己資本比率（％）</th>';
						for(let i=0; i<data.length; i++) {
							let thisNum = Number(data[i]).toLocaleString(undefined, {
								minimumFractionDigits: 1,
								maximumFractionDigits: 1
							});

							tableHtml += '<td>'+ thisNum +'</td>';
						}
						tableHtml += '</tr>';
					}

					// ROS
					if(data.indexOf('財務指標') !== -1) {
						highlightFlgIdx = idx2;
					}
					if(idx2 == Number(highlightFlgIdx + 1)) {
						chart2Labels = data;
						chart2Labels.shift();
						chart2Labels = chart2Labels.filter(item => item !== '\r');
					}
					if(String(data[0]).indexOf('ROS') !== -1) {
						chart2Data = data;
						chart2Data.shift();
						// 表
						rosHtml += '<tr><th>ROS（％）</th><td>'+ data.join('</td><td>') +'</td></tr>';
					}
					// ROE
					if(String(data[0]).indexOf('ROE') !== -1) {
						chart3Data = data;
						chart3Data.shift();

						// 表
						roeHtml += '<tr><th>ROE（％）</th><td>'+ data.join('</td><td>') +'</td></tr>';
					}

					// Net有利子負債・NetD/Eレシオ
					if(data.indexOf('Net有利子負債') !== -1) {
						chart4Data1 = data;
						chart4Data1.shift();

						// 表
						netHtml += '<tr><th>Net有利子負債（百万円）</th><td>'+ data.join('</td><td>') +'</td></tr>';
					}
					if(data.indexOf('Net D/E レシオ***（倍）') !== -1) {
						chart4Data2 = data;
						chart4Data2.shift();
						// 表
						netDEHtml += '<tr><th>Net D/E レシオ（倍）</th><td>'+ data.join('</td><td>') +'</td></tr>';
					}

					// キャッシュ・フロー
					if(data.indexOf('キャッシュフロー') !== -1) {
						cfFlgIdx = idx2;
					}
					if(idx2 == Number(cfFlgIdx + 1)) {
						chart5Labels = data;
						chart5Labels.shift();
						chart5Labels = chart5Labels.filter(item => item !== '\r');
					}
					if(data.indexOf('営業活動によるキャッシュ・フロー（百万円）') !== -1) {
						chart5Data1 = data;
						chart5Data1.shift();

						// 表
						cf1Html += '<tr><th>営業活動による<br>キャッシュ・フロー（百万円）</th>';
						for(let i=0; i<data.length; i++) {
							cf1Html += '<td>'+ Number(data[i]).toLocaleString() +'</td>';
						}
						cf1Html += '</tr>';
					}
					if(data.indexOf('投資活動によるキャッシュ・フロー（百万円）') !== -1) {
						chart5Data2 = data;
						chart5Data2.shift();

						// 表
						cf2Html += '<tr><th>投資活動による<br>キャッシュ・フロー（百万円）</th>';
						for(let i=0; i<data.length; i++) {
							cf2Html += '<td>'+ Number(data[i]).toLocaleString() +'</td>';
						}
						cf2Html += '</tr>';
					}
					if(data.indexOf('財務活動によるキャッシュ・フロー（百万円）') !== -1) {
						chart5Data3 = data;
						chart5Data3.shift();

						// 表
						cf3Html += '<tr><th>財務活動による<br>キャッシュ・フロー（百万円）</th>';
						for(let i=0; i<data.length; i++) {
							cf3Html += '<td>'+ Number(data[i]).toLocaleString() +'</td>';
						}
						cf3Html += '</tr>';
					}
					if(data.indexOf('フリー・キャッシュ・フロー（百万円）') !== -1) {
						chart5Data4 = data;
						chart5Data4.shift();
						
						// 表
						cf4Html += '<tr><th>フリー・キャッシュ・フロー（百万円）</th>';
						for(let i=0; i<data.length; i++) {
							cf4Html += '<td>'+ Number(data[i]).toLocaleString() +'</td>';
						}
						cf4Html += '</tr>';
					}
				});

				// グラフ
				chartCanvas.forEach((ele, idx) => {
					let thisId = ele.getAttribute('id');
					let ctx01 = document.querySelector('#'+ thisId);
					if(thisId === 'chart01') { // 総資産・純資産・自己資本比率
						let myChart = new Chart(ctx01, {
							type: 'bar',
							data: {
								labels: chart1Labels,
								datasets: [{
									label: '自己資本比率',
									type: 'line',
									lineTension: 0,
									data: chart1Data3,
									yAxisID: 'y-axis-1',
									backgroundColor: 'transparent',
									borderColor: mainColor1, // サーモンピンク		
								},{
									label: '総資産',
									data: chart1Data1,
									yAxisID: 'y-axis-2',
									backgroundColor: mainColor2, // 濃い水色
								},{
									label: '純資産',
									data: chart1Data2,
									yAxisID: 'y-axis-3',
									backgroundColor: mainColor3, // 明るい水色
								}],
							},
							options: {
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									},
									// onClick: (e, legendItem) => {
									// 	var index = legendItem.datasetIndex;
									// 	var ci = myChart;
									// 	var meta = ci.getDatasetMeta(index);

									// 	meta.hidden = meta.hidden === null? !ci.data.datasets[index].hidden : null;

									// 	ci.update();

									// 	let datasetsArr = ci.data.datasets;
									// 	let visibleItem = [];
									// 	let hiddenItem = [];
									// 	for(let i=0; i<datasetsArr.length; i++) {
									// 		if(datasetsArr[i]._meta[0].hidden === true) {
									// 			hiddenItem.push(datasetsArr[i].label);
									// 		} else {
									// 			visibleItem.push(datasetsArr[i].label);
									// 		}
									// 	}
										
									// 	if(hiddenItem.indexOf('総資産') !== -1 && visibleItem.indexOf('純資産') !== -1) {
									// 		ci.options.scales.yAxes[2].ticks.display = true;
									// 		ci.options.scales.yAxes[1].ticks.display = false;
									// 		ci.update();
									// 	} else {
									// 		ci.options.scales.yAxes[2].ticks.display = false;
									// 		ci.options.scales.yAxes[1].ticks.display = true;
									// 		ci.update();
									// 	}
									// }
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										id: 'y-axis-1',
										type: 'linear',
										position: 'right',
										ticks: {
											title: '自己資本比率',
											suggestedMin: 0,
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											color: '#e3e3e3',
											zeroLineColor: "#000"
										}
									},{
										id: 'y-axis-2',
										type: 'linear',
										position: 'left',
										ticks: {
											title: '総資産',
											suggestedMin: 0,
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											display: false,
											// color: '#e3e3e3',
											//zeroLineColor: "#000"
										}
									},{
										id: 'y-axis-3',
										type: 'linear',
										position: 'left',
										ticks: {
											display: false,
											title: '純資産',
											suggestedMin: 0,
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											display: false,
										}
									}],
									xAxes: [{
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										ticks: {
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												} else {
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItem, data){
											let num = tooltipItem.yLabel.toLocaleString();
											if(tooltipItem.datasetIndex === 0) {
												return Number(num).toFixed(1);
											} else {
												return num;
											}
										}
									}
								}
							}
						});

						// 最小値と最大値を揃える（個別設定）
						const chartData = myChart.controller.boxes;
						let yAxesArr = myChart.options.scales.yAxes;
						let leftMax, leftMin, rightMax, rightMin;
						
						chartData.forEach((ele,idx) => {
							if(ele.id === 'y-axis-1') {// 自己資本比率
								rightMax = ele.max;
								rightMin = ele.min;
							} else if(ele.id === 'y-axis-2') { // 総資産
								leftMax = ele.max;
								leftMin = ele.min;
							}
						});
						// 最小値と最大値を再設定
						for(let i=0; i<yAxesArr.length; i++) {
							if(yAxesArr[i].id === 'y-axis-1') {
								// 自己資本比率
								yAxesArr[i].ticks.min = rightMin;
								yAxesArr[i].ticks.max = rightMax;
							} else if(yAxesArr[i].id === 'y-axis-2' || yAxesArr[i].id === 'y-axis-3') {
									// 総資産、純資産
								yAxesArr[i].ticks.min = leftMin;
								yAxesArr[i].ticks.max = leftMax;
							}
						}
						myChart.update();
					} else if(thisId === 'chart02') {
						let myChart = new Chart(ctx01, {
							type: 'line',
							data: {
								labels: chart2Labels,
								datasets: [{
									label: 'ROS',
									data: chart2Data,
									yAxisID: 'y-axis-1',
									lineTension: 0,
									backgroundColor: 'transparent',
									borderColor: mainColor2, // 濃い水色
								}],
							},
							options: {
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										id: 'y-axis-1',
										position: 'left',
										ticks: {
											title: 'ROS',
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											color: '#e3e3e3',
											zeroLineColor: "#000"
										}
									}],
									xAxes: [{
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										ticks: {
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												} else {
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItem, data){
											return tooltipItem.yLabel.toFixed(1).toLocaleString();
										}
									}
								}
							}
						});
						updateScale(myChart);
					} else if(thisId === 'chart03') {
						let myChart = new Chart(ctx01, {
							type: 'line',
							data: {
								labels: chart2Labels,
								datasets: [{
									label: 'ROE',
									data: chart3Data,
									yAxisID: 'y-axis-1',
									lineTension: 0,
									backgroundColor: 'transparent',
									borderColor: mainColor1, // サーモンピンク
								}],
							},
							options: {
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										id: 'y-axis-1',
										position: 'left',
										ticks: {
											title: 'ROE',
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											color: '#e3e3e3',
											zeroLineColor: "#000"
										}
									}],
									xAxes: [{
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										ticks: {
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												} else {
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItem, data){
											return tooltipItem.yLabel.toFixed(1).toLocaleString();
										}
									}
								}
							}
						});
						updateScale(myChart);
					} else if(thisId === 'chart04') {
						let myChart = new Chart(ctx01, {
							type: 'bar',
							data: {
								labels: chart1Labels,
								datasets: [{
									label: 'Net D/E レシオ',
									type: 'line',
									data: chart4Data2,
									yAxisID: 'y-axis-1',
									lineTension: 0,
									backgroundColor: 'transparent',
									borderColor: mainColor1, // サーモンピンク		
								},{
									label: 'Net有利子負債',
									data: chart4Data1,
									yAxisID: 'y-axis-2',
									backgroundColor: mainColor3, // 明るい水色
								}],
							},
							options: {
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										id: 'y-axis-1',
										type: 'linear',
										position: 'right',
										ticks: {
											title: 'Net D/E レシオ',
											suggestedMin: 0,
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											color: '#e3e3e3',
											zeroLineColor: "#000"
										}
									},{
										id: 'y-axis-2',
										type: 'linear',
										position: 'left',
										ticks: {
											title: 'Net有利子負債',
											suggestedMin: 0,
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											display: false
											// color: '#e3e3e3',
											// zeroLineColor: "#000"
										}
									}],
									xAxes: [{
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										ticks: {
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												} else {
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItem, data){
											return tooltipItem.yLabel.toLocaleString();
										}
									}
								}
							}
						});
						// updateScale(myChart);
					} else if(thisId === 'chart05') {
						let myChart = new Chart(ctx01, {
							type: 'bar',
							data: {
								labels: chart5Labels,
								datasets: [{
									label: 'フリー・キャッシュ・フロー',
									type: 'line',
									data: chart5Data4,
									yAxisID: 'y-axis-1',
									lineTension: 0,
									backgroundColor: 'transparent',
									borderColor: mainColor1, // サーモンピンク		
								},{
									label: '営業活動によるキャッシュ・フロー',
									data: chart5Data1,
									yAxisID: 'y-axis-2',
									backgroundColor: mainColor2, // 濃い水色
								},{
									label: '投資活動によるキャッシュ・フロー',
									data: chart5Data2,
									yAxisID: 'y-axis-3',
									backgroundColor: mainColor3, // 明るい水色
								},{
									label: '財務活動によるキャッシュ・フロー',
									data: chart5Data3,
									yAxisID: 'y-axis-4',
									backgroundColor: mainColor4, // 明るい薄緑
								}],
							},
							options: {
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										id: 'y-axis-1',
										type: 'linear',
										position: 'right',
										ticks: {
											title: 'フリー・キャッシュ・フロー',
											fontColor: '#000',
											display: false,
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											display: false
										}
									},{
										id: 'y-axis-2',
										type: 'linear',
										position: 'left',
										ticks: {
											title: '営業活動によるキャッシュ・フロー',
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											color: '#e3e3e3',
											zeroLineColor: "#000"
										}
									},{
										id: 'y-axis-3',
										type: 'linear',
										position: 'right',
										ticks: {
											display: false,
											title: '投資活動によるキャッシュ・フロー',
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											display: false,
										}
									},{
										id: 'y-axis-4',
										type: 'linear',
										position: 'right',
										ticks: {
											display: false,
											title: '財務活動によるキャッシュ・フロー',
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
										gridLines: {
											display: false,
										}
									}],
									xAxes: [{
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										ticks: {
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												} else {
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItem, data){
											return tooltipItem.yLabel.toLocaleString();
										}
									}
								}
							}
						});
						updateScale(myChart);
					}
				});

				// 表
				if(document.querySelectorAll('.js-csvTbl-body').length) {
					// tableLabels.push('合計');
					tableHtml += rosHtml + roeHtml + netHtml + netDEHtml + cf1Html + cf2Html + cf3Html + cf4Html;
					document.querySelector('.js-csvTbl-body').insertAdjacentHTML('beforeend', tableHtml);
				}
			}
		}
	}

	// <セグメントデータ>
	const segmentDataCharts = () => {
		let csvFile = '/ir/highlight/segment_data/segment.csv';
		const chartCanvas = document.querySelectorAll('.js-chart');
		if(chartCanvas.length) {
			let chart1Labels = []; // 23年3月期セグメント別売上
			let segmentTotal; // 23年3月期セグメント別売上
			let chart2Labels = []; // セグメント別売上推移
			let chart1Data = []; // セグメント別売上推移(インキ事業)
			let chart2Data1 = []; // セグメント別売上推移(インキ事業)
			let chart2Data2 = []; // セグメント別売上推移(化成品事業)
			let chart2Data3 = []; // セグメント別売上推移(加工品事業)
			let chart2Data4 = []; // セグメント別売上推移(不動産賃貸事業)
			let chart2label1; // セグメント別売上推移(インキ事業)
			let chart2label2; // セグメント別売上推移(化成品事業)
			let chart2label3; // セグメント別売上推移(加工品事業)
			let chart2label4; // セグメント別売上推移(不動産賃貸事業)
			let chart3Data1 = [];
			let chart3Data2 = [];
			let chart3Data3 = [];
			let chart3Data4 = [];
			let chart2DataIdx = [];
			let tableYears;
			let tableLabels = [];
			let tableHtml = '';


			const req = new XMLHttpRequest();
			req.open('get', csvFile, true);
			req.send(null);
			req.onload = function(){
				let tmp = req.responseText.split('\n');

				tmp.forEach((val, idx) => {
					const data = val.split(',').filter(Boolean);
					
					// 23年3月期セグメント別売上（当期）
					if(data.indexOf('インキ事業') !== -1 || data.indexOf('化成品事業') !== -1 || data.indexOf('加工品事業') !== -1 || data.indexOf('不動産賃貸事業') !== -1) {
						if(chart1Labels.indexOf(data[0]) === -1) {
							chart1Labels.push(data[0]);
							chart1Data.push(data[data.length -1]);
							tableLabels.push(data[0]);
						}
					}
					if(data.indexOf('売上高') !== -1 && data.indexOf('合計') !== -1) {
						segmentTotal = data[data.length -1];
					}

					// セグメント別売上推移（直近10年間）
					if(data.indexOf('年度') !== -1) {
						data.shift();
						data.splice(data.indexOf('\r'), 1);
						tableYears = data;
						// 10年以上前の年号を削除
						if(data.length > 10) {
							data.splice(0, data.length - 10);
							tableYears.splice(0, data.length - 10);
						}
						for(let i=0; i<data.length; i++) {
							let year = data[i].split('年')[0] + '年';
							
							chart2Labels.push(year + '3月期');
						}
					}
					
					// 表
					if(data.indexOf('期') !== -1) {
						data.shift();
						data.splice(data.indexOf('\r'), 1);
						tableHtml += '<tr><th colspan="2" rowspan="2"></th>';
						for(let i=0; i<data.length; i++) {
							tableHtml += '<th colspan="4">' + tableYears[i] +'<br>'+ data[i] + '</th>'
						}
						tableHtml += '</tr><tr>';

						for(let i=0; i<tableYears.length; i++) {
							tableHtml += '<th>1Q</th><th>2Q</th><th>3Q</th><th>通期</th>';
						}
						tableHtml += '</tr>';
					}

					if(data.indexOf('通期') !== -1) {
						for(let i=0; i<data.length; i++) {
							let dataName = data[i].replace('\r', '');
							if(dataName === '通期') {
								chart2DataIdx.push(i);
							}
						}
					}

					if(data.indexOf('売上高') !== -1) {
						// 表
						tableHtml += '<tr>'
						for(let i=0; i<data.length; i++) {
							if(i === 0) {
								tableHtml += '<td rowspan="2">'+ data[i] +'</td>';
							} else {
								if(isNaN(data[i]) === false) {
									tableHtml += '<td>'+ Number(data[i]).toLocaleString() +'</td>';
								} else {
									tableHtml += '<td>'+ data[i] +'（百万円）</td>';
								}
							}
						}
						tableHtml += '</tr>';
						
						if(data.indexOf('インキ事業') !== -1) {
							chart2label1 = 'インキ事業';
							data.splice(0,2);
							for(let i=0; i<data.length; i++) {
								if(chart2DataIdx.indexOf(i) !== -1) {
									chart2Data1.push(data[i]);
								}
							}
						}
						if(data.indexOf('化成品事業') !== -1) {
							chart2label2 = '化成品事業';
							data.splice(0,2);
							for(let i=0; i<data.length; i++) {
								if(chart2DataIdx.indexOf(i) !== -1) {
									chart2Data2.push(data[i]);
								}
							}
						}
						if(data.indexOf('加工品事業') !== -1) {
							chart2label3 = '加工品事業';
							data.splice(0,2);
							for(let i=0; i<data.length; i++) {
								if(chart2DataIdx.indexOf(i) !== -1) {
									chart2Data3.push(data[i]);
								}
							}
						}
						if(data.indexOf('不動産賃貸事業') !== -1) {
							chart2label4 = '不動産賃貸事業';
							data.splice(0,2);
							for(let i=0; i<data.length; i++) {
								if(chart2DataIdx.indexOf(i) !== -1) {
									chart2Data4.push(data[i]);
								}
							}
						}
					}
					// セグメント別利益（直近10年間）
					if(data.indexOf('セグメント利益') !== -1) {
						// 表
						tableHtml += '<tr>';
						for(let i=0; i<data.length; i++) {
							if(i !== 0) {
								if(isNaN(data[i]) === false) {
									tableHtml += '<td>'+ Number(data[i]).toLocaleString() +'</td>';
								} else {
									tableHtml += '<td>'+ data[i] +'（百万円）</td>';
								}
							}
						}
						tableHtml += '</tr>';

						if(data.indexOf('インキ事業') !== -1) {
							data.splice(0,2);
							for(let i=0; i<data.length; i++) {
								if(chart2DataIdx.indexOf(i) !== -1) {
									chart3Data1.push(data[i]);
								}
							}
						}
						if(data.indexOf('化成品事業') !== -1) {
							data.splice(0,2);
							for(let i=0; i<data.length; i++) {
								if(chart2DataIdx.indexOf(i) !== -1) {
									chart3Data2.push(data[i]);
								}
							}
						}
						if(data.indexOf('加工品事業') !== -1) {
							data.splice(0,2);
							for(let i=0; i<data.length; i++) {
								if(chart2DataIdx.indexOf(i) !== -1) {
									chart3Data3.push(data[i]);
								}
							}
						}
						if(data.indexOf('不動産賃貸事業') !== -1) {
							data.splice(0,2);
							for(let i=0; i<data.length; i++) {
								if(chart2DataIdx.indexOf(i) !== -1) {
									chart3Data4.push(data[i]);
								}
							}
						}
					}
				});

				// グラフ
				chartCanvas.forEach((ele, idx) => {
					let thisId = ele.getAttribute('id');
					let myChart = document.querySelector('#'+ thisId);
	
					// 23年3月期セグメント別売上
					if(thisId === 'chart01') {
						// パネル
						for(let i=0; i<tableLabels.length; i++) {
							let thisHtml = '<p class="__title">'+ tableLabels[i] +'</p>';
							thisHtml += '<p class="__num">売上高<span>'+ Number(chart1Data[i]).toLocaleString() +'</span>百万円</p>';
							thisHtml += '<p class="__percentage">'+ (chart1Data[i] / segmentTotal * 100).toFixed(1) +'%</p>';
							document.querySelector('.js-panel0'+ Number(i+1)).innerHTML = thisHtml;
						}
						// セグメント別売上高構成比
						var dataLabelPlugin = {
							afterDatasetsDraw: function (chart, go) {
								let ctx = chart.ctx;
								chart.data.datasets.forEach((dataset, i) => {
									let dataSum = 0
									dataset.data.forEach((element) => {
										dataSum += Number(element)
									})

									let meta = chart.getDatasetMeta(i)
									if (!meta.hidden) {
										meta.data.forEach(function (element, index) {
											// フォントの設定
											let fontSize = 14
											let fontStyle = 'bold'
											let fontFamily = 'Helvetica Neue'
											ctx.fillStyle = '#000'
											// 設定を適用
											ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily)

											// ラベルをパーセント表示に変更
											let labelString = chart.data.labels[index];
											let dataString = Number(dataset.data[index]).toLocaleString() + '百万円';
											let percentageString = (dataset.data[index] / dataSum * 100).toFixed(1).toString() + '%';

											// positionの設定
											ctx.textAlign = 'center'
											ctx.textBaseline = 'middle'

											let padding = -2
											let position = element.tooltipPosition()
											// ツールチップに変更内容を表示
											ctx.fillText(labelString, position.x, position.y - (fontSize / 2) - padding) // title
											ctx.fillText(dataString, position.x, position.y + (fontSize *.8) - padding)  // データの百分率
											ctx.fillText(percentageString, position.x, position.y + (fontSize*2) - padding)  // データの百分率
										})
									}
								});
							}
						}
						let myDoughnutChart = new Chart(myChart, {
							type: 'doughnut',
							data: {
								labels: chart1Labels,
								datasets: [{
									backgroundColor: [pink, blue, green, orange],
									borderWidth: 1,
									data: chart1Data
								}]
							},
							options: {
								rotation: 89.54,
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								}
							},
							// plugins: [dataLabelPlugin],
						});

						document.querySelector('.js-segment-txt').innerHTML = Number(segmentTotal).toLocaleString() + '<br data-view="sp">百万円';

					} else if(thisId === 'chart02') {
						// セグメント別売上推移（直近10年間）
						let myBarChart = new Chart(myChart, {
							type: 'bar',
							data: {
								labels: chart2Labels,
								datasets: [{
									label: chart2label1,
									data: chart2Data1,
									backgroundColor: pink,
								},{
									label: chart2label2,
									data: chart2Data2,
									backgroundColor: blue,
								},{
									label: chart2label3,
									data: chart2Data3,
									backgroundColor: green,
								}
								,{
									label: chart2label4,
									data: chart2Data4,
									backgroundColor: orange,
								}]
							},
							options: {
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										stacked: true,
										ticks: {
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
									}],
									xAxes: [{
										stacked: true,
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										ticks: {
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												} else {
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItem, data){
											return tooltipItem.yLabel.toLocaleString() + '百万円';
										}
									}
								}
							}
						});
					} else if(thisId === 'chart03') {
						// セグメント別利益（直近10年間）
						let myBarChart = new Chart(myChart, {
							type: 'bar',
							data: {
								labels: chart2Labels,
								datasets: [{
									label: chart2label1,
									data: chart3Data1,
									backgroundColor: pink,
								},{
									label: chart2label2,
									data: chart3Data2,
									backgroundColor: blue,
								},{
									label: chart2label3,
									data: chart3Data3,
									backgroundColor: green,
								}
								,{
									label: chart2label4,
									data: chart3Data4,
									backgroundColor: orange,
								}]
							},
							options: {
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										stacked: true,
										ticks: {
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
									}],
									xAxes: [{
										stacked: true,
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										ticks: {
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													return [val.substr(0, 5), val.substr(5)]
												} else {
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItem, data){
											return tooltipItem.yLabel.toLocaleString() + '百万円';
										}
									}
								}
							}
						});
					}
				});

				// 表
				if(document.querySelectorAll('.js-csvTbl-body').length) {
					// tableLabels.push('合計');
					document.querySelector('.js-csvTbl-body').insertAdjacentHTML('beforeend', tableHtml);
				}
			}
		}
	}

	// <株主還元>
	const dividendDataCharts = () => {
		let csvFile = '/ir/stock/privilege/dividend.csv';
		const chartCanvas = document.querySelectorAll('.js-chart');
		if(chartCanvas.length) {
			let chart1Labels;
			let chart2Labels;
			let chart1Title1;
			let chart1Title2;
			let chart1Title3;
			let chart1Data1;
			let chart1Data2;
			let chart1Data3;
			let chart1Idx;
			let chart2Idx;
			let chart2Data;
			let tableYears;
			let tableHtml = '';

			const req = new XMLHttpRequest();
			req.open('get', csvFile, true);
			req.send(null);
			req.onload = function(){
				let tmp = req.responseText.split('\n');

				tmp.forEach((val, idx) => {
					const data = val.split(',').filter(Boolean);

					// 一株当たりの配当金の推移
					if(data.indexOf('一株当たりの配当金の推移') !== -1) {
						chart1Idx = idx;
					}
					if(idx === chart1Idx + 1) {
						chart1Labels = data;
						chart1Labels.shift();
						// 10年以上前の年号を削除
						if(data.length > 11) {
							data.splice(0, data.length - 11);
							chart1Labels.splice(0, data.length - 11);
						}
						tableHtml += '<tr><th rowspan="2"></th><th>'+ chart1Labels.join('</th><th>') +'</th></tr>'; 
					}

					// 表
					if(idx === chart1Idx + 2) {
						data.shift();
						tableHtml += '<tr><th>'+ data.join('</th><th>') +'</th></tr>'; 
					}

					if(data.indexOf('中間配当') !== -1) {
						chart1Title1 = data[0];
						chart1Data1 = data;	
						// 10年以上前のデータを削除
						if(data.length > 11) {
							data.splice(0, data.length - 11);
							chart1Data1.splice(0, data.length - 11);
						}
						tableHtml += '<tr><td>'+ chart1Title1 +'（円）</td><td>'+ chart1Data1.join('</td><td>') + '</td></tr>';
					}
					if(data.indexOf('期末配当') !== -1) {
						chart1Title2 = data[0];
						chart1Data2 = data;	
						// 10年以上前のデータを削除
						if(data.length > 11) {
							data.splice(0, data.length - 11);
							chart1Data2.splice(0, data.length - 11);
						}
						tableHtml += '<tr><td>'+ chart1Title2 +'（円）</td><td>'+ chart1Data2.join('</td><td>') + '</td></tr>';
					}
					if(data.indexOf('記念配当') !== -1) {
						chart1Title3 = data[0];
						chart1Data3 = data;	
						// 10年以上前のデータを削除
						if(data.length > 11) {
							data.splice(0, data.length - 11);
							chart1Data3.splice(0, data.length - 11)
							chart1Data3.forEach((ele, idx) => {
								if(ele === 'null') {
									chart1Data3[idx] = '';
								}
							});
						}
						tableHtml += '<tr><td>'+ chart1Title3 +'（円）</td>';
						for(let i=0; i<chart1Data3.length; i++) {
							if(chart1Data3[i] === '') {
								tableHtml += '<td>－</td>';
							} else {
								tableHtml += '<td>'+ chart1Data3[i] + '</td>';
							}
						}
						tableHtml += '</tr>';
					}

					// 注釈
					if(data.indexOf('注釈') !== -1) {
						data.shift();
						data.splice(data.indexOf('\r'), 1);
						document.querySelector('.js-chart-note').innerHTML = '<li>'+ data +'</li>';
					}

					// 配当性向
					if(data.indexOf('配当性向') !== -1) {
						if(data.length == 2) {
							chart2Idx = idx;
						} else {
							chart2Data = data;
							chart2Data.shift();
							// chart2Data.splice(chart2Data.indexOf('\r'), 1);

							// 10年以上前のデータを削除
							if(data.length > 11) {
								data.splice(0, data.length - 11);
								chart2Data.splice(0, data.length - 11)
								chart2Data.forEach((ele, idx) => {
									if(ele === 'null') {
										chart2Data[idx] = '';
									}
								});
							}

							// 表
							tableHtml += '<tr><td>配当性向（％）</td>';
							chart2Data.forEach((ele, idx) => {
								let thisNum = Number(chart2Data[idx]).toLocaleString(undefined, {
									minimumFractionDigits: 1,
									maximumFractionDigits: 1
								});
								tableHtml += '<td>'+ thisNum + '</td>';
							});
							tableHtml += '</tr>';
						}
					}
					if(idx === chart2Idx + 1) {
						chart2Labels = data;
						chart2Labels.shift();
						// chart2Labels.splice(chart2Labels.indexOf('\r'), 1);
						// 10年以上前のデータを削除
						if(data.length > 11) {
							data.splice(0, data.length - 11);
							chart2Labels.splice(0, data.length - 11)
							chart2Labels.forEach((ele, idx) => {
								if(ele === 'null') {
									chart2Labels[idx] = '';
								}
							});
						}
					}
				});

				// グラフ
				chartCanvas.forEach((ele, idx) => {
					let thisId = ele.getAttribute('id');
					let myChart = document.querySelector('#'+ thisId);

					if(thisId === 'chart01') {
						// 一株当たりの配当金の推移（直近10年間+予想）
						let myBarChart = new Chart(myChart, {
							type: 'bar',
							data: {
								labels: chart1Labels,
								datasets: [{
									label: chart1Title1,
									data: chart1Data1,
									backgroundColor: mainColor1,
								},{
									label: chart1Title2,
									data: chart1Data2,
									backgroundColor: mainColor3,
								},{
									label: chart1Title3,
									data: chart1Data3,
									backgroundColor: mainColor2,
								}]
							},
							options: {
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										stacked: true,
										ticks: {
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
									}],
									xAxes: [{
										stacked: true,
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										ticks: {
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													if(val.indexOf('（予定）') !== -1) {
														return [val.substr(0, 5), val.substr(5, 3), val.substr(8)]
													} else {
														return [val.substr(0, 5), val.substr(5)]
													}
												} else {
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItem, data){
											return tooltipItem.yLabel.toLocaleString();
										}
									}
								}
							}
						});
						updateScale(myBarChart);
					} else if(thisId === 'chart02') {
						// 配当性向（直近10年間+予想
						let myLineChart = new Chart(myChart, {
							type: 'line',
							data: {
								labels: chart2Labels,
								datasets: [{
									label: '配当性向',
									data: chart2Data,
									lineTension: 0,
									borderColor: mainColor1,
									backgroundColor: 'transparent',
								}]
							},
							options: {
								legend: {
									display: true,
									onHover: e => {
										e.currentTarget.style.cursor = 'pointer';

									},
									onLeave: e => {
										e.currentTarget.style.cursor = 'default';
									}
								},
								responsive: true,
								maintainAspectRatio: false,
								scales: {
									yAxes: [{
										// stacked: true,
										ticks: {
											fontColor: '#000',
											callback: function(value, index, values){
												return value.toLocaleString();
											}
										},
									}],
									xAxes: [{
										// stacked: true,
										gridLines: {
											color: 'transparent',
											zeroLineColor: "transparent"
										},
										ticks: {
											autoSkip: false,
											fontColor: '#000',
											callback: function(val){
												if(val.length > 5){
													if(val.indexOf('（予定）') !== -1) {
														return [val.substr(0, 5), val.substr(5, 3), val.substr(8)]
													} else {
														return [val.substr(0, 5), val.substr(5)]
													}
												} else {
													return val;
												}
											}
										}
									}]
								},
								tooltips: {
									callbacks: {
										label: function(tooltipItem, data){
											return tooltipItem.yLabel.toLocaleString(undefined, {
												minimumFractionDigits: 1,
												maximumFractionDigits: 1
											});
										}
									}
								}
							}
						});
						updateScale(myLineChart);
					}
				});

				// 表
				if(document.querySelectorAll('.js-csvTbl-body').length) {
					// tableLabels.push('合計');
					document.querySelector('.js-csvTbl-body').insertAdjacentHTML('beforeend', tableHtml);
				}
			}
		}
	};

	// =====================================================
	if($path === '/ir/highlight/performance_data/' || $path === '/ir/highlight/performance_data/index.html') {
		performanceDataCharts();
	} else if($path === '/ir/highlight/finance_data/' || $path === '/ir/highlight/finance_data/index.html') {
		financeDataCharts();
	} else if($path === '/ir/highlight/segment_data/' || $path === '/ir/highlight/segment_data/index.html') {
		segmentDataCharts();
	} else if($path === '/ir/stock/privilege/' || $path === '/ir/stock/privilege/index.html') {
		dividendDataCharts();
	}


})(window.FUNCTIONS);
